import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor() { }


  public test(){
    console.log("this is a test");
  }
}
